import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings';
import {
  businessDualKeyDetailsAddons,
  defaultBusinessGasDetailsAddons,
  defaultEstimatesDialog,
  ongoingKeyDetails,
} from './common/planDefaults';

export const originBusinessGoVariableOngoingContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Go Variable Ongoing']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: businessDualKeyDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728625503/spot-illustrations/illo_Origin-Variable-Business.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Choose energy with variable rates',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
